import type { SyncedLanguage } from '@/types/api';

interface LanguageFormProps {
  formData: Partial<SyncedLanguage>;
  onChange: (data: Partial<SyncedLanguage>) => void;
}

export function LanguageForm({ formData, onChange }: LanguageFormProps) {
  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Name *</label>
        <input
          type="text"
          value={formData.name || ''}
          onChange={(e) => onChange({ ...formData, name: e.target.value })}
          className="input w-full"
          required
        />
      </div>
      <div className="flex items-center">
        <input
          type="checkbox"
          id="isEnabled"
          checked={formData.isEnabled ?? false}
          onChange={(e) => onChange({ ...formData, isEnabled: e.target.checked })}
          className="h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500"
        />
        <label htmlFor="isEnabled" className="ml-2 text-sm text-gray-700">Enabled</label>
      </div>
    </div>
  );
}
